// src/mixins/update.js
import store from '@/store'
export default {
    data() {
      return {		
        alert:{
			show: false,
			message: ''
		},
		success:{
			show: false,
			message: ''
		}
      }
	},
	
	computed: {
		notifications (){
			return store.state.notifications
		},
		notification_count (){
			return store.state.notification_count
		},
		latest_notification(){
			return store.state.latest_notification
		},		
	},
	watch:{
		notification_count: function(new_value,old_value){
			if (this.latest_notification && new_value > old_value){				
				this.showSuccess(`${this.latest_notification.data.title} : ${this.latest_notification.data.message}`)
			}
		}
	},	
  
    methods: {
		showSuccess: function(message){
			this.success.message = message
			// Get the snackbar DIV
			var x = document.getElementById("success-snackbar")			
			// Add the "show" class to DIV
			x.classList.add("show")
			// After 7 seconds, remove the show class from DIV	
			setTimeout(function(){
				x.classList.remove("show")
			}, 4000)
		},
		// show notification alert (error message)
		showAlert: function(message){
			this.alert.message = message
			// Get the snackbar DIV
			var x = document.getElementById("alert-snackbar");
			// Add the "show" class to DIV
			x.classList.add("show")
			// After 3 seconds, remove the show class from DIV
			setTimeout(function(){
				x.classList.remove("show") 
			}, 4000);
		},	

		/* Set the width of the side navigation to 250px */
		openNotifications:function() {
			var notification_div = document.getElementById("notification-div")			
			notification_div.style.width = "300px"
		},
		/* Set the width of the side notification div to 0 */
		closeNotifications:function() {
			var notification_div = document.getElementById("notification-div")
			notification_div.style.width = "0px"
		},
    },
  }